/*
  Langue du premier accès.

  Un appareil français ouvre la boutique en français; toute autre langue ouvre
  l'anglais. Dès que la personne choisit FR ou EN elle-même, ce choix devient
  prioritaire et l'automatisme ne le remplace plus.
*/
(() => {
  const forms = [...document.querySelectorAll('[data-locale-form]')];
  if (forms.length === 0) return;

  const shopify = typeof window.Shopify === 'object' && Boolean(window.Shopify.shop);
  const local =
    window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  const MANUAL_KEY = 'makalu_locale_manual';
  const ATTEMPT_KEY = 'makalu_locale_attempt';
  let automaticSubmission = false;

  const lireStockage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  };

  const ecrireStockage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch {
      /* Le cookie ci-dessous reste le repli en navigation privée. */
    }
  };

  const lireCookie = (key) =>
    document.cookie
      .split('; ')
      .find((entry) => entry.startsWith(`${key}=`))
      ?.split('=')[1] || '';

  const memoriserChoix = (code) => {
    ecrireStockage(window.localStorage, MANUAL_KEY, code);
    document.cookie = `${MANUAL_KEY}=${encodeURIComponent(code)}; Max-Age=15552000; Path=/; SameSite=Lax`;
  };

  const racines = [...forms[0].querySelectorAll('[data-locale-url]')]
    .map((button) => button.dataset.localeUrl)
    .filter(Boolean)
    .map((root) => root.replace(/\/$/, ''))
    .filter((root) => root && root !== '/')
    .sort((a, b) => b.length - a.length);

  const cheminSansLangue = (pathname) => {
    for (const root of racines) {
      if (pathname === root || pathname.startsWith(`${root}/`)) {
        return pathname.slice(root.length) || '/';
      }
    }
    return pathname || '/';
  };

  const urlLocale = (button) => {
    const root = (button.dataset.localeUrl || '').replace(/\/$/, '');
    const path = cheminSansLangue(window.location.pathname);
    return `${root}${path === '/' ? '/' : path}${window.location.search}${window.location.hash}`;
  };

  for (const form of forms) {
    form.addEventListener('submit', (event) => {
      const button = event.submitter;
      const code = button?.name === 'locale_code' ? button.value : '';
      if (!code) return;

      const returnTo = form.querySelector('[data-locale-return]');
      if (returnTo) returnTo.value = `${window.location.pathname}${window.location.search}`;
      if (!automaticSubmission) memoriserChoix(code);

      /*
        Shopify reçoit le vrai formulaire POST. Le serveur local ne possède pas
        `/localization`; il utilise donc directement les racines des langues.
      */
      if (shopify && !local) return;
      event.preventDefault();
      window.location.assign(urlLocale(button));
    });
  }

  const manual =
    lireStockage(window.localStorage, MANUAL_KEY) || lireCookie(MANUAL_KEY);
  const attempted = lireStockage(window.sessionStorage, ATTEMPT_KEY);
  const explicitLocale = racines.some(
    (root) =>
      window.location.pathname === root || window.location.pathname.startsWith(`${root}/`)
  );
  if (manual || attempted || explicitLocale) return;

  const languages =
    Array.isArray(navigator.languages) && navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language || 'en'];
  const primaryLanguage = String(languages[0] || 'en').toLowerCase();
  const desired = primaryLanguage === 'fr' || primaryLanguage.startsWith('fr-') ? 'fr' : 'en';
  const current = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  ecrireStockage(window.sessionStorage, ATTEMPT_KEY, desired);
  if (desired === current) return;

  const button = forms[0].querySelector(
    `[data-locale-url][name="locale_code"][value="${desired}"]`
  );
  if (!button) return;
  automaticSubmission = true;
  forms[0].requestSubmit(button);
})();
